export default __webpack_public_path__ + "static/media/poster_eventos_tablet_1200.95be4442.webp";